export const name = "TIMESTAMP";
export const summary = `Constructs a \`TIMESTAMP\` value.`;
export const reference = `
## TIMESTAMP

Constructs a \`TIMESTAMP\` value.

\`\`\`
TIMESTAMP(string_expression[, time_zone])
TIMESTAMP(date_expression[, time_zone])
TIMESTAMP(datetime_expression[, time_zone])
\`\`\`

### Description

- \`string_expression[, time_zone]\`: Converts a string to a timestamp. \`string_expression\` must include a timestamp literal. If \`string_expression\` includes a time zone in the timestamp literal, don't include an explicit \`time_zone\`argument.
- \`date_expression[, time_zone]\`: Converts a date to a timestamp. The value returned is the earliest timestamp that falls within the given date.
- \`datetime_expression[, time_zone]\`: Converts a datetime to a timestamp.

This function supports an optional parameter to specify a time zone. If no time zone is specified, the default time zone, UTC, is used.


### Return Data Type

\`TIMESTAMP\`


### Examples



\`\`\`
SELECT TIMESTAMP("2008-12-25 15:30:00+00") AS timestamp_str;

-- Display of results may differ, depending upon the environment and time zone where this query was executed.
/*-------------------------*
 | timestamp_str |
 +-------------------------+
 | 2008-12-25 15:30:00 UTC |
 *-------------------------*/
\`\`\`



\`\`\`
SELECT TIMESTAMP("2008-12-25 15:30:00", "America/Los_Angeles") AS timestamp_str;

-- Display of results may differ, depending upon the environment and time zone where this query was executed.
/*-------------------------*
 | timestamp_str |
 +-------------------------+
 | 2008-12-25 23:30:00 UTC |
 *-------------------------*/
\`\`\`



\`\`\`
SELECT TIMESTAMP("2008-12-25 15:30:00 UTC") AS timestamp_str;

-- Display of results may differ, depending upon the environment and time zone where this query was executed.
/*-------------------------*
 | timestamp_str |
 +-------------------------+
 | 2008-12-25 15:30:00 UTC |
 *-------------------------*/
\`\`\`



\`\`\`
SELECT TIMESTAMP(DATETIME "2008-12-25 15:30:00") AS timestamp_datetime;

-- Display of results may differ, depending upon the environment and time zone where this query was executed.
/*-------------------------*
 | timestamp_datetime |
 +-------------------------+
 | 2008-12-25 15:30:00 UTC |
 *-------------------------*/
\`\`\`



\`\`\`
SELECT TIMESTAMP(DATE "2008-12-25") AS timestamp_date;

-- Display of results may differ, depending upon the environment and time zone where this query was executed.
/*-------------------------*
 | timestamp_date |
 +-------------------------+
 | 2008-12-25 00:00:00 UTC |
 *-------------------------*/
\`\`\`


source: https://cloud.google.com/bigquery/docs/reference/standard-sql/timestamp_functions
`;
